module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn",
    class: _vm.classtype,
    attrs: {
      "id": "custom-button-submit",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fe05269"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/ButtonSubmit.vue
// module id = 76
// module chunks = 0